<template
  ><layout name="Clean"
    ><div class="register-email-sent">
      <VSystemMessage
        :primaryText="sysMessageTitle"
        :secondaryText="sysMessageSecondaryText"
      >
        <div
          class="send-again"
          :class="{ ['disabled']: !isBtnActive }"
          @click="sendEmailAgain"
        >
          Send email again
        </div>
        <div class="timer" v-show="time">You can resend it in {{ time }} seconds</div>
      </VSystemMessage>
    </div></layout
  ></template
>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions } from "vuex";
import Layout from "@/layouts/Layout";

//components
import VSystemMessage from "@/components/VSystemMessage";

//mixins
import withToasted from "@/mixins/withToasted";

export default Vue.component("OnBoardingEmailSent", {
  props: {},
  components: {
    Layout,
    VSystemMessage
  },

  mixins: [withToasted],

  data() {
    return {
      sysMessageTitle: "We have sent an email",
      sysMessageSecondaryText:
        "If the email has not arrived,\n" +
        "you can send it again by clicking on the link below",
      time: null,
      timer: null,
      isBtnActive: false
    };
  },

  methods: {
    sendEmailAgain() {
      this.sendOnboardingEmail({
        email: this.email,
        onSuccess: () => {
          this.toast("All right");
          this.startTimer();
        },
        onError: () => this.errorToast("Something went wrong")
      });
    },

    startTimer() {
      this.time = 60;
      return (this.timer = setInterval(() => {
        this.time--;
        if (this.time === 0) {
          this.clearTimeout(this.timer);
        }
      }, 1000));
    },

    stopTimer() {
      clearTimeout(this.timer);
    },

    ...mapActions("auth", ["sendOnboardingEmail"])
  },

  mounted() {
    this.startTimer();
  },

  watch: {
    time(val) {
      if (val === 0) {
        this.stopTimer();
        this.isBtnActive = true;
      }
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "register-email-sent";
.#{$ns} {
  display: flex;
  height: 100%;

  &/deep/.v-system-message__wrapper {
    margin: auto;
  }
}

.send-again {
  margin-top: 100px;
  cursor: pointer;
  color: $primary-color;
  font-size: 20px;
  line-height: 1.3;
  text-decoration: underline;

  &.disabled {
    pointer-events: none;
    opacity: 25%;
  }
}

.timer {
  margin-top: 20px;
  font-size: 15px;
}
</style>
